/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import React from 'react';

import LegendItem from 'reports/DashboardReports/Charts/common/LegendItem';

const LegendContainer = (props) => {
  const color = '#7f00b4';
  let currentOpacity = 1;
  const opacityJump = 1 / props.items.length;

  return (
    <section className={`legend-container ${props.additionalClass ? props.additionalClass : ''}`}>
      {props.items.map((item, i) => {
        const opacityForHtml = currentOpacity;
        currentOpacity -= opacityJump;
        return (
          <div className="legend-item" key={`{${item.val}_${i}_div}`}>
            <span className="dot-color" style={{ backgroundColor: color, opacity: opacityForHtml }} key={`{${item.val}_${i}_span}`} />

            <LegendItem prefix={props.prefix} suffix={props.suffix} key={`{${item.val}_${i}_legendItem}`} itemText={item.text} itemValue={item.val} />
          </div>
        );
      })}
    </section>
  );
};

export default LegendContainer;
